import * as React from "react";
import User from "../../_data/models/User";
import SearchResult from "../../_data/models/SearchResult";
interface Props {
    result: SearchResult;
    user: User;
    viewItem: () => void;
}

const SearchTrendingUserComponent = (props: Props) => {
    const {result, user, viewItem} = props;

    return (
        <li>
            <div className="media-object">
                <div className="media-object-section flushed middle">
                    <div className="img-wrapper small circle">
                        <img src={user.profilePicture()}/>
                    </div>
                </div>
                <div className="media-object-section middle">
                    <div className="text-group">
                        <p>
                            <b>{user.username()}</b>
                            {result.distance &&
                            <small className="ml-1">{result.distanceInMiles()} Miles</small>
                            }
                        </p>
                        <small className="subheader">{user.profession}</small>
                    </div>
                </div>
            </div>
            <a className="button primary pull-right" onClick={viewItem}>View Profile</a>
        </li>
    );
};
export default SearchTrendingUserComponent;


// WEBPACK FOOTER //
// ./app/client/search/components/SearchTrendingUserComponent.tsx